export default __webpack_public_path__ + "static/media/home.a2d99abc.md";